<script>
import pagination from "@/mixins/pagination";
import taskDefaultList from "@/mixins/taskDefaultList";
import BaseSubNav from "@/components/ui/BaseSubNav.vue";

export default {
  name: "CheckinsDefaultList",

  mixins: [pagination, taskDefaultList],

  components: {
    BaseSubNav,
  },

  data() {
    return {
      configType: "checkins",
    };
  },
};
</script>

<template lang="pug">
  section
    BaseSubNav(
      navigationType="treatment"
      :showNavigation="true"
    )
      template(#title)
        | Check-in
        small(v-if="pagination.total")  ({{ pagination.total }})
      template(#actions)
        el-input.search__input(prefix-icon="el-icon-search" v-on:input="debounceInput" v-model="searchInput" placeholder="Buscar" :clearable="true")
        router-link.button.button--blue(:to="{name: 'create-task', params: { taskType: 'checkins' }}" v-auth="'task-default.create'")
          micon(name="add_circle_outline").button__icon
          span.button__text Nuevo Check-in
    .box.box--with-subnav
      .box__content--stretch
        table
          thead
            tr
              th Nombre del Check-in
              th Descripcion
              th Acciones
          tbody
            spinner(v-if="isLoading && !tasks.length")
            tr(v-else, v-for="c in tasks", :key="c._id")
              td {{ c.name }}
              td {{ c.description }}
              td.actions
                .actions-container
                  button.button.button--action(@click="edit(c._id)")
                    micon(name="edit")
                  button.button.button--action(@click="remove(c)")
                    micon(name="delete_forever")
      pagination(
        :isLoading="isLoading"
        :limit="pagination.limit",
        :total="pagination.total",
        @pagination="setPagination"
      )
</template>
